export const SALES_REPORT_ROUTE_STORAGE_KEY = 'sales-reports-route'
